import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';
import { ModalService } from 'src/app/services/modal.service';
import { CartPaymentModalComponent } from '../../cart/modal/cart-payment-modal/cart-payment-modal.component';

@Component({
  selector: 'order-sidebar-menu',
  templateUrl: './order-sidebar-menu.component.html',
  styleUrls: ['./order-sidebar-menu.component.scss']
})
export class OrderSidebarMenuComponent implements OnInit {

  @Input("order") order:any = null;
  @Output("close") close:any = new EventEmitter();
  public loader = false;

  constructor(
    private app: AppService,
    private api: ApiService,
    private modal: ModalService,
    private dialog: MatDialog
  ){}

  /**
   * 
   * Close
   * 
   */
  _close(){

    this.close.emit();

  }
  /**
   * 
   * Confirmar o cancelamento.
   * 
   */
  _confirmCancel(){

    this.modal.confirm(
      "Você deseja cancelar essa cotação?",
      this,
      {
        fnCallback: this._cancelOrder
      }
    );

  }
  /**
   * 
   * Candel order
   * 
   */
  _cancelOrder(loader,self){

    try{

      self.loader = true;

      self.api.sale().order().cancel(self.order.id).subscribe((response:any) => {

        self.loader = false;

        if(response.status == 1){

          self.order.cart_status_id = 4;
          self.order.status         = "Cancelado";
          self.close.emit();

          self.modal.open("A cotação foi cancelada com sucesso.");

        }else{

          let error   = self.api.formatError(response);
          this.modal.open(error.message);

        }

      },(response:any) => { 

        self.loader = false;
        let error   = self.api.formatError(response);
        self.app.open(error.message);
        
      });

    }catch(e){

      self.loader = false;

    }

  }
  /**
   * 
   * Open pay
   * 
   */
  openPay(){

    this.dialog.open(
      CartPaymentModalComponent,{
        width: "800px",
        data: {
          id: this.order.id,
          navigateApproved: false,
          update: (data:any):any => {

            this.order.status         = data.status;
            this.order.cart_status_id = data.cart_status_id;

          }
        }
      }
    )

  }
  /**
   * 
   * I
   * 
   */
  ngOnInit():void{}

}
